module.exports = __webpack_public_path__ + "media/images/gift_plan/bubble-img-otoku-1month-9ea104defa7277b7d3a8cc4f70e0cccf.png";